import { v4 as uuid } from 'uuid';
import {
	horizon,
	RDR2,
	Fifa,
	AOE4,
	GOW,
	Batman,
	valorant,
	civilization,
	AOE2,
	NBA,
	sekiro,
	witcher,
	mario,
	codmw,
	gtav,
	rl,
	minecraft,
	portal,
} from '../../Assets/images';

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
	{
		_id: '3fbe8787-7618-4606-aee2-5df44023578b',
		title: 'Batman: Arkham Knight',
		description: `Batman: Arkham Knight brings the award-winning Arkham trilogy from Rocksteady Studios to its epic conclusion. Developed exclusively for New-Gen platforms, Batman: Arkham Knight introduces Rocksteady's uniquely designed version of the Batmobile. The highly anticipated addition of this legendary vehicle, combined with the acclaimed gameplay of the Arkham series, offers gamers the ultimate and complete Batman experience as they tear through the streets and soar across the skyline of the entirety of Gotham City.`,
		badge: '',
		image: Batman,
		price: 1349,
		discount: 17,
		rating: 4.5,
		reviewers: 42,
		categoryName: 'Action',
	},
	{
		_id: '9d8b7008-53b7-4ef1-ae7a-a9bf3cafe69b',
		title: 'Red Dead Redemption 2',
		description:
			'Winner of over 175 Game of the Year Awards and recipient of over 250 perfect scores, RDR2 is the epic tale of outlaw Arthur Morgan and the infamous Van der Linde gang, on the run across America at the dawn of the modern age. Also includes access to the shared living world of Red Dead Online.',
		badge: '',
		image: RDR2,
		price: 3299,
		discount: 30,
		rating: 3.5,
		reviewers: 28,
		categoryName: 'Action',
	},
	{
		_id: '1df47f33-50e1-4b4d-9e7e-7f73cabf42c9',
		title: 'Fifa 2022',
		description:
			'Powered by Football, EA SPORTS FIFA 22 brings the game even closer to the real thing with fundamental gameplay advances and a new season of innovation across every mode.',
		badge: '',
		image: Fifa,
		price: 4199,
		discount: 45,
		rating: 4,
		reviewers: 34,
		categoryName: 'Sports',
	},
	{
		_id: '041b5d72-d90c-45ba-8f28-4df2e15b36f3',
		title: 'Horizon Forbidden West',
		description: `Horizon Forbidden West is a 2022 action role-playing game developed by Guerrilla Games and published by Sony Interactive Entertainment. A sequel to 2017's Horizon Zero Dawn, the game is set in a post-apocalyptic version of the Western United States, which has been overrun by a deadly plague.`,
		badge: 'New',
		image: horizon,
		price: 4999,
		discount: 25,
		rating: 4.5,
		reviewers: 56,
		categoryName: 'RPG',
	},
	{
		_id: '0e2a940c-4819-4a54-81a5-d8f57993c01b',
		title: 'God of War',
		description:
			'His vengeance against the Gods of Olympus years behind him, Kratos now lives as a man in the realm of Norse Gods and monsters. It is in this harsh, unforgiving world that he must fight to survive… and teach his son to do the same.',
		badge: 'New',
		image: GOW,
		price: 3299,
		discount: 12,
		rating: 4.5,
		reviewers: 30,
		categoryName: 'RPG',
	},
	{
		_id: '511c319d-e584-4433-b861-63d0fb652f09',
		title: 'Age of Empires IV',
		description:
			'One of the most beloved real-time strategy games returns to glory with Age of Empires IV, putting you at the center of epic historical battles that shaped the world.',
		badge: '',
		image: AOE4,
		price: 3299,
		discount: 20,
		rating: 4,
		reviewers: 54,
		categoryName: 'Strategy',
	},
	{
		_id: 'b012cb96-201f-4a05-b4bc-134d98909817',
		title: 'Valorant',
		description:
			'Valorant is a first-person hero shooter developed and published by Riot Games, for Microsoft Windows.',
		badge: 'Out of Stock',
		image: valorant,
		price: 1149,
		rating: 1.5,
		reviewers: 3,
		categoryName: 'Action',
	},
	{
		_id: '300c8fe7-db61-404a-aad2-e8b10ee1b227',
		title: 'Civilization VI',
		description:
			'Civilization VI offers new ways to interact with your world, expand your empire across the map, advance your culture, and compete against history’s greatest leaders to build a civilization that will stand the test of time. Play as one of 20 historical leaders including Roosevelt (America) and Victoria (England).',
		badge: 'Out of Stock',
		image: civilization,
		price: 2499,
		discount: 50,
		rating: 3,
		reviewers: 23,
		categoryName: 'Strategy',
	},
	{
		_id: 'd251ff01-9051-4fc2-b336-535b30591f00',
		title: 'Age of Empires 2',
		description:
			'Age of Empires II has been re-imagined in high definition with new features, trading cards, improved AI, workshop support, multiplayer, Steamworks integration and more!',
		badge: '',
		image: AOE2,
		price: 899,
		discount: 0,
		rating: 3.5,
		reviewers: 152,
		categoryName: 'Strategy',
	},
	{
		_id: '6944f288-124f-4ec9-8ef5-4ce351b6feb9',
		title: 'NBA 2K22',
		description:
			'NBA 2K22 puts the entire basketball universe in your hands. Anyone, anywhere can hoop in NBA 2K22.',
		badge: 'New',
		image: NBA,
		price: 3199,
		discount: 67,
		rating: 3.5,
		reviewers: 29,
		categoryName: 'Sports',
	},
	{
		_id: '5dd8e435-52ec-4e04-9cc0-1fbfb108fbe2',
		title: 'Sekiro Shadows Die Twice',
		description:
			'Explore late 1500s Sengoku Japan, a brutal period of constant life and death conflict, as you come face to face with larger than life foes in a dark and twisted world. Unleash an arsenal of deadly prosthetic tools and powerful ninja abilities while you blend stealth, vertical traversal, and visceral head to head combat in a bloody confrontation.',
		badge: '',
		image: sekiro,
		price: 1699,
		discount: 30,
		rating: 2.5,
		reviewers: 43,
		categoryName: 'Action',
	},
	{
		_id: '91bb055b-87c6-463a-b3c9-546cf82cd2c5',
		title: 'The Witcher 3: Wild Hunt',
		description:
			'As war rages on throughout the Northern Realms, you take on the greatest contract of your life — tracking down the Child of Prophecy, a living weapon that can alter the shape of the world.',
		badge: '',
		image: witcher,
		price: 1999,
		discount: 20,
		rating: 4,
		reviewers: 59,
		categoryName: 'RPG',
	},
	{
		_id: '46c5cdf0-cc23-44b4-9271-93fcc86fee20',
		title: 'Mario Golf: Super Rush',
		description:
			'Mario Golf: Super Rush is a golf video game developed by Camelot Software Planning and published by Nintendo for the Nintendo Switch console. It is the sixth installment in the Mario Golf series following Mario Golf: World Tour in 2014 and is part of the larger Mario franchise.',
		badge: '',
		image: mario,
		price: 1399,
		discount: 0,
		rating: 4,
		reviewers: 78,
		categoryName: 'Sports',
	},
	{
		_id: 'b75cb869-a94d-4ddd-8b0c-ccd0e674ff74',
		title: 'Call of Duty: Modern Warfare',
		description:
			'Call of Duty: Modern Warfare is a 2019 first-person shooter game developed by Infinity Ward and published by Activision.',
		badge: '',
		image: codmw,
		price: 2750,
		discount: 10,
		rating: 3.5,
		reviewers: 122,
		categoryName: 'Action',
	},
	{
		_id: '4d6f7abc-9785-45ca-b9b9-fdb12b3cba98',
		title: 'Grand Theft Auto V',
		description:
			"Grand Theft Auto V is a 2013 action-adventure game developed by Rockstar North and published by Rockstar Games. It is the seventh main entry in the Grand Theft Auto series, following 2008's Grand Theft Auto IV, and the fifteenth instalment overall.",
		badge: '',
		image: gtav,
		price: 3200,
		discount: 12,
		rating: 4,
		reviewers: 157,
		categoryName: 'RPG',
	},
	{
		_id: 'c3b4b256-745e-4da0-b63e-82597886176f',
		title: 'Rocket League',
		description:
			'Rocket League is a vehicular soccer video game developed and published by Psyonix. The game was first released for Microsoft Windows and PlayStation 4 in July 2015',
		badge: '',
		image: rl,
		price: 2100,
		discount: 20,
		rating: 4,
		reviewers: 157,
		categoryName: 'Sports',
	},
	{
		_id: '05db6a65-d39b-4aba-b108-9ae6500d14fb',
		title: 'Minecraft',
		description:
			'Minecraft is a sandbox video game developed by Mojang Studios. The game was created by Markus "Notch" Persson.',
		badge: '',
		image: minecraft,
		price: 800,
		discount: '',
		rating: 3.5,
		reviewers: 15,
		categoryName: 'Strategy',
	},
	{
		_id: '99ee6b21-a58b-4909-b1d4-1a1aae6b956a',
		title: 'Portal 2',
		description:
			"Portal 2 is a 2011 puzzle-platform video game developed by Valve for Windows, Mac OS X, Linux, PlayStation 3, and Xbox 360. The digital PC version is distributed online by Valve's Steam service, while all retail editions were distributed by Electronic Arts.",
		badge: '',
		image: portal,
		price: 1200,
		discount: '',
		rating: 4,
		reviewers: 117,
		categoryName: 'Strategy',
	},
];
